// ng build

export const environment = {
    production: false,
    version: 'Beta',
    onlyGivis: false,
    baseUrl: 'https://apidemo.giviapp.com',
    siteUrl: 'https://ewallet.giviapp.com',
    logoIcon: 'icon-givi.png',
    logo: 'icon-givi.png',
    s3Url: 'https://givi-us-east-2.s3.us-east-2.amazonaws.com',
    googleClientId: '700888858472-7nuci480ompsspomuh5jug2o9ioiks7n.apps.googleusercontent.com',
    // Publishable keys de Stripe. Son públicas por diseño: solo sirven para tokenizar
    // en el navegador. La cuenta es la misma que usa el backend para cobrar.
    // stpPKTest se usa en modo demo (SessionManager.isDemoMode), que es lo que también
    // manda el header X-TESTMODE con el que el backend elige su secret key de test.
    stpPK: "pk_test_51QpVV8GAXuwy11LQVnZYMoj9jGSD655VT6pNsH0cuY8ntBy2rctSQJHDpn7FgchbdO9CYJX7jRlJ0FrwxA1IB4s800z2a6jV9j",
    stpPKTest: "pk_test_51QpVV8GAXuwy11LQVnZYMoj9jGSD655VT6pNsH0cuY8ntBy2rctSQJHDpn7FgchbdO9CYJX7jRlJ0FrwxA1IB4s800z2a6jV9j"
};
